import { render, staticRenderFns } from "./MultiMedia.vue?vue&type=template&id=6848ab81&scoped=true&"
import script from "./MultiMedia.vue?vue&type=script&lang=js&"
export * from "./MultiMedia.vue?vue&type=script&lang=js&"
import style0 from "./MultiMedia.vue?vue&type=style&index=0&id=6848ab81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6848ab81",
  null
  
)

export default component.exports